import React from "react";
import {
  FaDollarSign,
  FaUsers,
  FaFileInvoiceDollar,
  FaStickyNote,
  FaCartPlus,
  FaUser,
  FaBusinessTime,
  FaUserClock,
  FaGift,
  FaFileDownload,
  FaBoxes,
  FaTag,
  FaHome,
  FaHandshake,
  FaUserShield,
  FaTerminal,
  FaCoins,
} from "react-icons/fa";
import { MdOutgoingMail } from "react-icons/md";

// ── Admin sidebar ─────────────────────────────────────────────────────────────
//
// Each item declares the PERMISSION that reveals it, not a list of roles. This
// is the difference that makes the whole feature work: with `roles: ["admin",
// "sales"]` hardcoded here, creating a "marketing" role meant editing this file
// and redeploying. With `permission: "admin.marketing.emails"`, a new role
// simply gets the box ticked in the Roles screen and the item appears.
//
// The permission named should be the one that loads the page's main listing —
// if a user cannot fetch the list, the page is useless to them and the link
// should not be shown.
//
// `portals` narrows an item to particular portals when the permission alone is
// not enough to distinguish them. The two dashboards are the only real case:
// they are different pages for different portals.
//
// Items are hidden, not disabled. A section header disappears automatically once
// all of its items are hidden — see AdminLeftSidebar.
//
// Hiding a link is cosmetic. The route guard and, ultimately, the server decide
// what a user can actually reach.
export const managementSections = [
  {
    title: "",
    items: [
      {
        title: "Dashboard",
        path: "/admin/dashboard",
        icon: <FaHome />,
        permission: "admin.dashboard.trails",
        portals: ["admin"],
      },
      {
        title: "Dashboard",
        path: "/admin/resellerdashboard",
        icon: <FaHome />,
        permission: "reseller.dashboard.show",
        portals: ["reseller"],
      },
      {
        title: "Buy Credits",
        path: "/Admin/BuyCredits",
        icon: <FaCoins />,
        permission: "reseller.credits.request",
        portals: ["reseller"],
      },
    ]
  },
  {
    title: "License Management",
    items: [
      {
        title: "Licenses",
        path: "/Admin/Licenses",
        icon: <FaStickyNote />,
        // Shared screen: admins see every license, resellers only their own.
        permission: ["admin.licenses.index", "reseller.licenses.index"],
      },
      {
        title: "Trial Licenses",
        path: "/Admin/triallicenses",
        icon: <FaUsers />,
        permission: "admin.trial_licenses.index",
      },
      {
        title: "Trial Verify Codes",
        path: "/Admin/TrialVerificationCodes",
        icon: <FaUserClock />,
        permission: "admin.verification_codes.trial_index",
      },
      {
        title: "License Verify Codes",
        path: "/Admin/LicenseVerificationCodes",
        icon: <FaUserClock />,
        permission: "admin.verification_codes.license_index",
      },
      {
        title: "Users",
        path: "/Admin/Users",
        icon: <FaUser />,
        // Shared screen: admins see every user, resellers only their own.
        permission: ["admin.users.index", "reseller.users.index"],
      },
      {
        title: "Resellers",
        path: "/Admin/Resellers",
        icon: <FaHandshake />,
        permission: "admin.resellers.index",
      },
    ]
  },
  {
    title: "Monitoring",
    items: [
      {
        title: "Command Logs",
        path: "/Admin/CommandLogs",
        icon: <FaTerminal />,
        permission: "admin.command_logs.index",
      },
    ]
  },
  {
    title: "Payment management",
    items: [
      {
        title: "Generated Orders",
        path: "/Admin/Order/generated",
        icon: <FaBusinessTime />,
        permission: "admin.orders.generated",
      },
      {
        title: "Completed Orders",
        path: "/Admin/Orders/completed",
        icon: <FaDollarSign />,
        permission: "admin.orders.completed",
      },
    ]
  },
  {
    title: "Marketing",
    items: [
      {
        title: "Send Emails",
        path: "/Admin/SendEmail",
        icon: <MdOutgoingMail />,
        permission: "admin.marketing.emails",
      },
      {
        title: "Requested Quotes",
        path: "/Admin/Quotes",
        icon: <FaCartPlus />,
        permission: "admin.marketing.quotes_index",
      },
      {
        title: "Coupons",
        path: "/Admin/Coupons",
        icon: <FaGift />,
        permission: "admin.coupons.index",
      },
    ]
  },
  {
    title: "Sales",
    items: [
      {
        title: "User Profiles",
        path: "/Admin/UserProfiles",
        icon: <FaFileDownload />,
        permission: "admin.user_profiles.index",
      },
      {
        title: "Documents",
        path: "/Admin/Documents",
        icon: <FaFileInvoiceDollar />,
        permission: "admin.documents.index",
      },
    ]
  },
  {
    title: "Core",
    items: [
      {
        title: "Active Products",
        path: "/Admin/Products",
        icon: <FaFileInvoiceDollar />,
        permission: "admin.products.index",
      },
      {
        title: "Active Services",
        path: "/Admin/Services",
        icon: <FaBoxes />,
        permission: "admin.services.index",
      },
      {
        title: "Manage Tags",
        path: "/Admin/Tags",
        icon: <FaTag />,
        permission: "admin.tags.index",
      },
      {
        title: "Roles",
        path: "/Admin/Roles",
        icon: <FaUserShield />,
        permission: "admin.roles.index",
      },
    ]
  },
];
